import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FertilityDashboardRoutingModule } from './fertility-dashboard-routing.module';
import { FertilityHomePageComponent } from './pages/fertility-home-page/fertility-home-page.component';
import { RegionPageComponent } from './pages/region-page/region-page.component';
import { HttpClientModule } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [
    FertilityHomePageComponent,
    RegionPageComponent,
  ],
  imports: [
    CommonModule,
    FertilityDashboardRoutingModule,
    SharedModule,
    HttpClientModule,
  ],
})
export class FertilityDashboardModule {}
